import { render, staticRenderFns } from "./degreeApplication.vue?vue&type=template&id=4ae922bc&scoped=true"
import script from "./degreeApplication.vue?vue&type=script&lang=js"
export * from "./degreeApplication.vue?vue&type=script&lang=js"
import style0 from "./degreeApplication.vue?vue&type=style&index=0&id=4ae922bc&lang=scss"
import style1 from "./degreeApplication.vue?vue&type=style&index=1&id=4ae922bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae922bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae922bc')) {
      api.createRecord('4ae922bc', component.options)
    } else {
      api.reload('4ae922bc', component.options)
    }
    module.hot.accept("./degreeApplication.vue?vue&type=template&id=4ae922bc&scoped=true", function () {
      api.rerender('4ae922bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/academicDegree/degreeApplication.vue"
export default component.exports